(function(){
  'use strict';
  if(window.__hpWheelPurchaseGuard)return;
  window.__hpWheelPurchaseGuard=true;

  var productCache={};
  var bypassForms=typeof WeakSet==='function'?new WeakSet():null;
  var dialog=null;
  var dialogResolve=null;
  var accessoryState=null;

  function escapeHtml(value){return String(value||'').replace(/[&<>"]/g,function(character){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[character];});}
  function tagsText(product){var tags=product&&product.tags||[];return(Array.isArray(tags)?tags.join(' '):String(tags)).toLowerCase();}
  function vendorText(product){return String(product&&product.vendor||'').trim().toLowerCase();}
  function isCallOnly(product){var tags=tagsText(product),vendor=vendorText(product),identity=String(product&&product.title||'')+' '+String(product&&product.handle||'');return tags.indexOf('wheelpros brand')!==-1||tags.indexOf('wheelpros brands')!==-1||tags.indexOf('call only')!==-1||tags.indexOf('kg1-wheel')!==-1||vendor.indexOf('wheel pros')!==-1||vendor.indexOf('kg1')!==-1||/\bkg1\b/i.test(identity);}
  function isWheel(product){
    if(!product)return document.body&&document.body.dataset.suffix==='wheels-hq';
    var type=String(product.type||product.product_type||'').toLowerCase();
    var title=String(product.title||'');
    var vendor=vendorText(product);
    var known=/american racing|asanti|black rhino|fuel off-road|kmc|method wheels|method race|moto metal|rotiform|vossen|xd series|kg1|wheel pros|raceline|enkei|bbs|weld|vision wheel|foose|forgestar|konig|mayhem|fifteen52/.test(vendor);
    return isCallOnly(product)||type.indexOf('wheel')!==-1||tagsText(product).indexOf('wheel')!==-1||known||/\bwheel\b/i.test(title)||/\b\d{2}(?:\.\d+)?x\d+(?:\.\d+)?\b/i.test(title);
  }

  function requestJson(url){
    if(typeof window.fetch==='function')return window.fetch(url,{credentials:'same-origin'}).then(function(response){if(!response.ok)throw new Error('Request failed');return response.json();});
    return new Promise(function(resolve,reject){var xhr=new XMLHttpRequest();xhr.open('GET',url,true);xhr.onreadystatechange=function(){if(xhr.readyState!==4)return;if(xhr.status>=200&&xhr.status<300){try{resolve(JSON.parse(xhr.responseText));}catch(error){reject(error);}}else reject(new Error('Request failed'));};xhr.send();});
  }

  function productPath(form){
    var card=form&&form.closest?form.closest('.cm_product-item,.js-product-card,.product-card,[data-product-card]'):null;
    var link=card&&card.querySelector('a[href*="/products/"]');
    var path=link&&link.getAttribute('href');
    if(!path&&window.location.pathname.indexOf('/products/')===0)path=window.location.pathname;
    if(!path)return'';
    try{path=new URL(path,window.location.origin).pathname;}catch(error){}
    return path.split('?')[0].replace(/\/$/,'');
  }

  function getProduct(form){
    var path=productPath(form);
    if(!path)return Promise.resolve(null);
    if(productCache[path])return Promise.resolve(productCache[path]);
    return requestJson(path+'.js').then(function(product){productCache[path]=product;return product;}).catch(function(){return null;});
  }

  function ensureDialog(){
    if(dialog)return dialog;
    dialog=document.createElement('dialog');
    dialog.className='hp-wheel-guard';
    dialog.setAttribute('aria-labelledby','hp-wheel-guard-title');
    document.body.appendChild(dialog);
    dialog.addEventListener('cancel',function(event){event.preventDefault();settleDialog('cancel');});
    dialog.addEventListener('click',function(event){
      if(event.target===dialog)settleDialog('cancel');
      var addon=event.target.closest&&event.target.closest('[data-hp-wheel-addon]');
      if(addon){
        event.preventDefault();
        var key=addon.getAttribute('data-hp-wheel-addon');
        if(accessoryState&&accessoryState[key]){
          var next=!accessoryState[key].selected;
          if(next&&(key==='rubber'||key==='metal')){
            if(accessoryState.rubber)accessoryState.rubber.selected=false;
            if(accessoryState.metal)accessoryState.metal.selected=false;
            if(accessoryState.tpms)accessoryState.tpms.selected=false;
          }
          if(next&&key==='tpms'){
            if(accessoryState.rubber)accessoryState.rubber.selected=false;
            if(accessoryState.metal)accessoryState.metal.selected=false;
          }
          accessoryState[key].selected=next;
          renderAccessorySelections();
        }
        return;
      }
      var action=event.target.closest&&event.target.closest('[data-hp-wheel-action]');
      if(action){event.preventDefault();settleDialog(action.getAttribute('data-hp-wheel-action'));}
    });
    return dialog;
  }

  function settleDialog(value){
    if(!dialogResolve)return;
    var resolve=dialogResolve;dialogResolve=null;
    if(dialog&&dialog.open)dialog.close();
    resolve(value);
  }

  function ask(options){
    var modal=ensureDialog();
    var actions=(options.actions||[]).map(function(action){
      if(action.href)return'<a href="'+escapeHtml(action.href)+'">'+escapeHtml(action.label)+'</a>';
      return'<button type="button" data-hp-wheel-action="'+escapeHtml(action.value)+'"'+(action.secondary?' data-hp-wheel-secondary':'')+'>'+escapeHtml(action.label)+'</button>';
    }).join('');
    modal.innerHTML='<div class="hp-wheel-guard__head"><span class="hp-wheel-guard__eyebrow">'+escapeHtml(options.eyebrow||'Wheel order check')+'</span><h2 id="hp-wheel-guard-title">'+escapeHtml(options.title)+'</h2></div><div class="hp-wheel-guard__body"><p>'+escapeHtml(options.message)+'</p>'+(options.product?'<p class="hp-wheel-guard__product">'+escapeHtml(options.product)+'</p>':'')+'<div class="hp-wheel-guard__actions">'+actions+'</div>'+(options.foot?'<p class="hp-wheel-guard__foot">'+escapeHtml(options.foot)+'</p>':'')+'</div>';
    return new Promise(function(resolve){dialogResolve=resolve;if(typeof modal.showModal==='function')modal.showModal();else modal.setAttribute('open','');});
  }

  function quantityInput(form){return form.querySelector('[name="quantity"]');}
  function formQuantity(form){var input=quantityInput(form);var value=Number(input&&input.value||1);return Number.isFinite(value)&&value>0?Math.round(value):1;}
  function setQuantity(form,value){var input=quantityInput(form);if(!input){input=document.createElement('input');input.type='hidden';input.name='quantity';form.appendChild(input);}input.value=String(value);input.dispatchEvent(new Event('change',{bubbles:true}));}
  function fitmentLabel(form){
    var property=form.querySelector('[name="properties[Fitment]"]');
    if(property&&property.value)return property.value.replace(/^Fits your\s+/i,'');
    if(window.HurreysWheelHQ&&window.HurreysWheelHQ.vehicleLabel)return window.HurreysWheelHQ.vehicleLabel;
    var status=document.querySelector('[data-hwh-vehicle-status],[data-hp-cm-status]');
    return status?String(status.textContent||'').replace(/^Shopping(?: wheels)? for:\s*/i,'').replace(/\.$/,''):'';
  }

  function hiddenProperty(form,name,value){
    if(!value)return;
    var selector='input[name="properties['+name+']"]';
    var input=form.querySelector(selector);
    if(!input){input=document.createElement('input');input.type='hidden';input.name='properties['+name+']';form.appendChild(input);}
    input.value=value;
  }

  function vehicleData(label){
    var vehicle=window.HurreysWheelHQ&&window.HurreysWheelHQ.vehicle;
    if(vehicle&&vehicle.Year&&vehicle.Make&&vehicle.Model)return vehicle;
    var cm=window.Convermax;
    if(cm&&typeof cm.getVehicle==='function'){
      try{
        var selected=cm.getVehicle();
        if(selected&&Array.isArray(selected.selection))selected=selected.selection.reduce(function(result,item){if(item&&item.field)result[item.field]=item.term||item.value||'';return result;},{});
        if(selected&&selected.Year&&selected.Make&&selected.Model)return selected;
      }catch(error){}
    }
    var match=String(label||'').match(/^(\d{4})\s+(\S+)\s+(.+)$/);
    return match?{Year:match[1],Make:match[2],Model:match[3],Submodel:''}:{};
  }

  function yearMatches(range,year){
    return String(range||'').split(',').some(function(part){
      var match=part.trim().match(/^(\d{4})(?:-(\d{4}))?$/);
      if(!match)return false;
      return Number(year)>=Number(match[1])&&Number(year)<=Number(match[2]||match[1]);
    });
  }

  function productFitsVehicle(product,vehicle){
    if(!vehicle||!vehicle.Year||!vehicle.Make||!vehicle.Model)return false;
    var make=String(vehicle.Make).toLowerCase();var model=String(vehicle.Model).toLowerCase();var submodel=String(vehicle.Submodel||'').toLowerCase();
    var tags=product&&product.tags||[];if(!Array.isArray(tags))tags=String(tags).split(',');
    return tags.some(function(tag){
      if(String(tag).indexOf('fits_')!==0)return false;
      return String(tag).slice(5).split('~').some(function(application){
        var parts=application.split('`');
        if(parts.length<3||!yearMatches(parts[0],vehicle.Year)||String(parts[1]).toLowerCase()!==make||String(parts[2]).toLowerCase()!==model)return false;
        return !submodel||!parts[3]||String(parts[3]).toLowerCase()===submodel;
      });
    });
  }

  function isTurn14(product){return /(?:^|\s)turn14_id:/i.test(Array.isArray(product&&product.tags)?product.tags.join(' '):String(product&&product.tags||''));}
  function availableVariant(product){var variants=product&&product.variants||[];return variants.filter(function(variant){return variant&&variant.available!==false;})[0]||null;}
  function cents(product){var variant=availableVariant(product);return Number(variant&&variant.price||0);}
  function money(centsValue){return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(Number(centsValue||0)/100);}

  function packCount(product,kind){
    var source=String(product&&product.title||'')+' '+String(product&&product.description||'').replace(/<[^>]+>/g,' ');
    if(kind==='tpms'){
      var tpms=source.match(/(?:incl\.?\s*)?(\d+)\s*(?:-?valve mounted|tpms sensors?|sensors?)/i)||source.match(/(\d+)\s*wheel\s*tpms/i)||source.match(/set of\s*(\d+)/i);
      if(tpms)return Number(tpms[1]);
      if(/sold individually|single sensor/i.test(source))return 1;
      return 0;
    }
    var lugs=source.match(/(\d+)\s*lug nuts?/i);var locks=source.match(/(\d+)\s*locks?/i);
    if(lugs)return Number(lugs[1])+(locks?Number(locks[1]):0);
    var count=source.match(/(?:set of|\b)(\d+)\s*(?:pc\.?|piece|pack)/i);
    return count?Number(count[1]):0;
  }

  function loadProductPath(path){
    if(productCache[path])return Promise.resolve(productCache[path]);
    return requestJson(path+'.js').then(function(product){productCache[path]=product;return product;}).catch(function(){return null;});
  }

  function searchSuggestions(query){
    var url='/search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,vendor,body';
    return requestJson(url).then(function(response){
      return response&&response.resources&&response.resources.results&&response.resources.results.products||[];
    }).catch(function(){return[];});
  }

  function searchProductQueries(queries){
    return Promise.all(queries.map(searchSuggestions)).then(function(groups){
      var seen={};var items=[];
      groups.forEach(function(group){group.forEach(function(item){var key=String(item&&item.handle||'');if(!key||seen[key])return;seen[key]=true;items.push(item);});});
      return Promise.all(items.map(function(item){return loadProductPath('/products/'+item.handle);}));
    }).then(function(products){return products.filter(Boolean);});
  }

  function lugCountFor(form,product){
    var direct=form.querySelector('[name="properties[Lug count per wheel]"]');var value=Number(direct&&direct.value||0);if(value>0)return value;
    var bolt=form.querySelector('[name="properties[Bolt pattern]"]');var source=String(bolt&&bolt.value||'')+' '+String(window.HurreysWheelHQ&&window.HurreysWheelHQ.boltPattern||'')+' '+String(product&&product.title||'');var match=source.match(/(?:^|\s)(\d+)\s*[xX]\s*\d/);
    return match?Number(match[1]):0;
  }

  function chooseLugKit(products,vehicle,required){
    return products.filter(function(product){
      return isTurn14(product)&&availableVariant(product)&&/lug nuts?/i.test(String(product.type||'')+' '+String(product.title||''))&&productFitsVehicle(product,vehicle)&&packCount(product,'lugs')>=required&&!/custom shank/i.test(product.title||'');
    }).sort(function(a,b){
      var countA=packCount(a,'lugs'),countB=packCount(b,'lugs');var scoreA=(countA===required?100:0)+(/spline|cone/i.test(a.title||'')?20:0)-Math.abs(countA-required);var scoreB=(countB===required?100:0)+(/spline|cone/i.test(b.title||'')?20:0)-Math.abs(countB-required);return scoreB-scoreA;
    })[0]||null;
  }

  function chooseTpms(products,vehicle,wheelQuantity){
    return products.filter(function(product){
      var count=packCount(product,'tpms');return isTurn14(product)&&availableVariant(product)&&/tpms|tire pressure monitor/i.test(String(product.title||'')+' '+String(product.description||''))&&productFitsVehicle(product,vehicle)&&(count===wheelQuantity||count===1);
    }).sort(function(a,b){return(packCount(b,'tpms')===wheelQuantity?10:0)-(packCount(a,'tpms')===wheelQuantity?10:0);})[0]||null;
  }

  function accessoryProduct(product,quantity,unitCount,note){
    var variant=availableVariant(product);
    return product&&variant?{product:product,variant:variant,quantity:quantity,unitCount:unitCount,price:cents(product)*quantity,note:note,selected:false}:null;
  }

  function findAccessories(form,product){
    var label=fitmentLabel(form);var vehicle=vehicleData(label);var wheelQuantity=formQuantity(form);var lugsPerWheel=lugCountFor(form,product);var lugsRequired=lugsPerWheel?lugsPerWheel*wheelQuantity:0;
    var searches=[];
    searches.push(label&&lugsRequired?searchProductQueries([label+' lug nut kit',label+' lug nuts']):Promise.resolve([]));
    searches.push(label?searchProductQueries([label+' TPMS sensor',label+' tire pressure monitoring sensor']):Promise.resolve([]));
    searches.push(Promise.all(['/products/wheel-mate-tr413-rubber-valve-stem','/products/wheel-mate-bolt-on-metal-outer-mount-valve-stem'].map(loadProductPath)));
    return Promise.all(searches).then(function(results){
      var lugProduct=chooseLugKit(results[0],vehicle,lugsRequired);var tpmsProduct=chooseTpms(results[1],vehicle,wheelQuantity);var tpmsCount=packCount(tpmsProduct,'tpms');var stems=results[2];
      return{
        vehicle:vehicle,label:label,wheelQuantity:wheelQuantity,lugsPerWheel:lugsPerWheel,lugsRequired:lugsRequired,
        lugs:accessoryProduct(lugProduct,1,packCount(lugProduct,'lugs'),'Thread pitch is vehicle-matched; Hurrey’s verifies the wheel-seat style before fulfillment.'),
        tpms:accessoryProduct(tpmsProduct,tpmsCount===1?wheelQuantity:1,wheelQuantity,'Not pre-programmed. Sensors require programming or a vehicle relearn after installation.'),
        rubber:accessoryProduct(stems[0],wheelQuantity,wheelQuantity,'Standard rubber stems. Choose these only when TPMS sensors are not being added.'),
        metal:accessoryProduct(stems[1],wheelQuantity,wheelQuantity,'Bolt-on metal stems. Choose these only when TPMS sensors are not being added.')
      };
    }).catch(function(){return{vehicle:vehicle,label:label,wheelQuantity:wheelQuantity,lugsPerWheel:lugsPerWheel,lugsRequired:lugsRequired,lugs:null,tpms:null,rubber:null,metal:null};});
  }

  function addonCard(key,title,item,badge,description){
    if(!item)return'<div class="hp-wheel-addon hp-wheel-addon--unavailable"><span class="hp-wheel-addon__badge">'+escapeHtml(badge)+'</span><strong>'+escapeHtml(title)+'</strong><p>'+escapeHtml(description)+'</p><small>Not auto-added—call 609-249-4921 and we will match it.</small></div>';
    return'<button class="hp-wheel-addon" type="button" data-hp-wheel-addon="'+escapeHtml(key)+'" aria-pressed="false"><span class="hp-wheel-addon__badge">'+escapeHtml(badge)+'</span><span class="hp-wheel-addon__title"><strong>'+escapeHtml(title)+'</strong><b>'+escapeHtml(money(item.price))+'</b></span><span class="hp-wheel-addon__product">'+escapeHtml(item.product.title)+'</span><span class="hp-wheel-addon__note">'+escapeHtml(item.note)+'</span><span class="hp-wheel-addon__state" data-hp-addon-state>Add</span></button>';
  }

  function renderAccessorySelections(){
    if(!dialog||!accessoryState)return;
    dialog.querySelectorAll('[data-hp-wheel-addon]').forEach(function(button){var key=button.getAttribute('data-hp-wheel-addon');var selected=!!(accessoryState[key]&&accessoryState[key].selected);button.setAttribute('aria-pressed',String(selected));button.classList.toggle('is-selected',selected);var state=button.querySelector('[data-hp-addon-state]');if(state)state.textContent=selected?'Added':'Add';});
    updateAccessorySubtotal();
  }

  function updateAccessorySubtotal(){
    if(!dialog||!accessoryState)return;var total=0;Object.keys(accessoryState).forEach(function(key){var item=accessoryState[key];if(item&&item.selected&&item.price)total+=item.price;});var output=dialog.querySelector('[data-hp-addon-subtotal]');if(output)output.textContent=total?'Selected extras: '+money(total):'No extras selected — wheels only';
  }

  function showAccessories(plan){
    accessoryState={lugs:plan.lugs,tpms:plan.tpms,rubber:plan.rubber,metal:plan.metal};
    var modal=ensureDialog();var lugMath=plan.lugsPerWheel?plan.lugsPerWheel+' lugs × '+plan.wheelQuantity+' wheel'+(plan.wheelQuantity===1?'':'s')+' = '+plan.lugsRequired+' lug nuts':'Lug count needs a vehicle fitment check';var tpmsMath=plan.wheelQuantity+' wheel'+(plan.wheelQuantity===1?'':'s')+' = '+plan.wheelQuantity+' TPMS sensor'+(plan.wheelQuantity===1?'':'s');
    modal.innerHTML='<div class="hp-wheel-guard__head"><span class="hp-wheel-guard__eyebrow">Complete your wheel install</span><h2 id="hp-wheel-guard-title">Add only what you want.</h2></div><div class="hp-wheel-guard__body hp-wheel-guard__body--addons"><p class="hp-wheel-guard__intro">Your wheels are ready. Tap an add-on to include it, or continue with wheels only.</p><div class="hp-wheel-math"><strong>'+escapeHtml(lugMath)+'</strong><strong>'+escapeHtml(tpmsMath)+'</strong></div><div class="hp-wheel-addons">'+addonCard('lugs','Full lug hardware set',plan.lugs,'Vehicle matched',plan.label?'No verified full kit was found for '+plan.label+'.':'Choose a vehicle to match lug thread and quantity.')+addonCard('tpms','TPMS for every wheel',plan.tpms,'Programming required',plan.label?'No exact '+plan.wheelQuantity+'-sensor match was found for '+plan.label+'.':'Choose a vehicle to match sensor frequency.')+'</div><div class="hp-wheel-stems"><div><span class="hp-wheel-addon__badge">Optional valve stems</span><strong>Rubber or metal—not both</strong><p>TPMS kits use their own compatible stems. Choosing a standalone stem option removes TPMS from this order.</p></div><div class="hp-wheel-stems__choices">'+addonCard('rubber','Rubber stems',plan.rubber,'Qty '+plan.wheelQuantity,'Rubber stems are unavailable online right now.')+addonCard('metal','Metal bolt-on stems',plan.metal,'Qty '+plan.wheelQuantity,'Metal stems are unavailable online right now.')+'</div></div><div class="hp-wheel-addon__subtotal" data-hp-addon-subtotal>No extras selected — wheels only</div></div><div class="hp-wheel-guard__checkout"><div class="hp-wheel-guard__actions"><button type="button" data-hp-wheel-action="add-selected">Add wheels + selected extras</button><button type="button" data-hp-wheel-action="wheels-only" data-hp-wheel-secondary>Wheels only</button></div><p class="hp-wheel-guard__foot"><strong>Nothing is preselected.</strong> TPMS sensors are not pre-programmed and require programming or relearn after installation. Hurrey’s reviews lug thread, seat style and sensor application before fulfillment.</p></div>';
    renderAccessorySelections();
    return new Promise(function(resolve){dialogResolve=resolve;if(typeof modal.showModal==='function')modal.showModal();else modal.setAttribute('open','');});
  }

  function formProperties(form){
    var properties={};form.querySelectorAll('[name^="properties["]').forEach(function(input){var match=input.name.match(/^properties\[(.+)\]$/);if(match&&input.value)properties[match[1]]=input.value;});return properties;
  }

  function addWheelAndExtras(form,plan){
    attachWheelPlan(form);var id=form.querySelector('[name="id"]');var items=[{id:Number(id&&id.value||0),quantity:formQuantity(form),properties:formProperties(form)}];
    ['lugs','tpms','rubber','metal'].forEach(function(key){var item=accessoryState&&accessoryState[key];if(!item||!item.selected)return;var properties={'Matched vehicle':plan.label||'Vehicle review needed','Wheel order quantity':String(plan.wheelQuantity)};if(key==='lugs'){properties['Hardware count']=String(item.unitCount);properties['Wheel seat review']='Required before fulfillment';}if(key==='tpms'){properties['TPMS programming']='Not pre-programmed; programming or relearn required';}if(key==='rubber'||key==='metal')properties['TPMS compatibility']='Standalone stem selected; no TPMS sensor included';items.push({id:Number(item.variant.id),quantity:item.quantity,properties:properties});});
    if(!items[0].id)throw new Error('Wheel variant missing');
    return window.fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})}).then(function(response){if(!response.ok)throw new Error('Cart request failed');return response.json();}).then(function(){window.location.href='/cart';});
  }

  function offerAccessories(form,product,submitter){
    return findAccessories(form,product).then(function(plan){return showAccessories(plan).then(function(choice){
      if(choice==='wheels-only'){accessoryState=null;resumeForm(form,submitter);return;}
      if(choice==='add-selected'){
        var hasSelected=accessoryState&&Object.keys(accessoryState).some(function(key){return accessoryState[key]&&accessoryState[key].selected;});
        if(!hasSelected){accessoryState=null;resumeForm(form,submitter);return;}
        return addWheelAndExtras(form,plan).catch(function(){accessoryState=null;return ask({title:'The extras did not add cleanly.',message:'Your wheel selection is still safe. Continue with the wheels only, or return and try again.',actions:[{label:'Add wheels only',value:'continue'},{label:'Return to wheels',value:'cancel',secondary:true}]}).then(function(next){if(next==='continue')resumeForm(form,submitter);});});
      }
    });}).catch(function(){resumeForm(form,submitter);});
  }

  function attachWheelPlan(form){
    var stance='';
    try{stance=sessionStorage.getItem('hurreysWheelStance')||'';}catch(error){}
    hiddenProperty(form,'Wheel stance preference',stance);
    hiddenProperty(form,'Vehicle for wheel review',fitmentLabel(form));
    hiddenProperty(form,'Wheel fitment review','Confirm bolt pattern, center bore, width, offset, load and brake clearance before mounting');
  }

  function resumeForm(form,submitter){
    attachWheelPlan(form);
    if(bypassForms)bypassForms.add(form);else form.setAttribute('data-hp-wheel-bypass','true');
    if(typeof form.requestSubmit==='function')form.requestSubmit(submitter||undefined);else form.submit();
  }

  function handleWheelQuantity(form,product,submitter){
    var quantity=formQuantity(form);
    var vehicle=fitmentLabel(form);
    var spareVehicle=/\b(jeep|wrangler|gladiator|bronco)\b/i.test(vehicle);
    function continueOrder(){return offerAccessories(form,product,submitter);}
    function askForSpare(){
      return ask({title:'Want a matching fifth wheel?',message:'Jeep and Bronco builds often carry a full-size spare. Add a fifth matching wheel now, or keep the set at four.',product:vehicle,actions:[{label:'Add the fifth wheel',value:'five'},{label:'Keep 4 wheels',value:'keep',secondary:true}],foot:'This is a suggestion, not a requirement.'}).then(function(choice){if(choice==='five'){setQuantity(form,5);hiddenProperty(form,'Matching spare decision','5-wheel set selected');return continueOrder();}if(choice==='keep'){hiddenProperty(form,'Matching spare decision','Customer chose 4 wheels');return continueOrder();}});
    }
    if(quantity<4){
      return ask({title:'Are you sure you only need '+quantity+'?',message:'Most wheel orders are a set of four. Continue with '+quantity+', or update this order to four wheels.',product:product&&product.title,actions:[{label:'Change to 4 wheels',value:'four'},{label:'Yes, keep '+quantity,value:'keep',secondary:true}],foot:'You can still order a single replacement wheel—we just want to prevent an accidental quantity.'}).then(function(choice){if(choice==='four'){setQuantity(form,4);if(spareVehicle)return askForSpare();return continueOrder();}if(choice==='keep')return continueOrder();});
    }
    if(quantity===4&&spareVehicle){
      return askForSpare();
    }
    return continueOrder();
  }

  function handleSubmit(event){
    var form=event.target;
    if(!form||!form.matches||!form.matches('form[action*="/cart/add"]'))return;
    if((bypassForms&&bypassForms.has(form))||form.getAttribute('data-hp-wheel-bypass')==='true'){
      if(bypassForms)bypassForms.delete(form);else form.removeAttribute('data-hp-wheel-bypass');
      return;
    }
    event.preventDefault();event.stopImmediatePropagation();
    var submitter=event.submitter||null;
    getProduct(form).then(function(product){
      if(isCallOnly(product)){
        return ask({eyebrow:'Browse online · call to order',title:'Let’s verify this wheel before ordering.',message:'Wheel Pros and KG1 products cannot be added to the online cart. Hurrey’s will confirm the exact vehicle, bolt pattern, center bore, offset, availability and price with you.',product:product&&product.title,actions:[{label:'Call 609-249-4921',href:'tel:6092494921'},{label:'Keep browsing',value:'cancel',secondary:true}],foot:'Mounted wheels are non-returnable, so this review happens before the order is placed.'});
      }
      if(isWheel(product))return handleWheelQuantity(form,product,submitter);
      resumeForm(form,submitter);
    });
  }

  function cartWheelReview(){
    return requestJson('/cart.js').then(function(cart){
      var items=cart&&cart.items||[];
      return Promise.all(items.map(function(item){
        if(!item.handle)return Promise.resolve(null);
        var path='/products/'+item.handle;
        if(productCache[path])return Promise.resolve(productCache[path]);
        return requestJson(path+'.js').then(function(product){productCache[path]=product;return product;}).catch(function(){return null;});
      })).then(function(products){
        var callOnly=[];var wheelQuantity=0;var wheelTitles=[];
        products.forEach(function(product,index){
          if(isCallOnly(product))callOnly.push(product);
          if(isWheel(product)){
            wheelQuantity+=Number(items[index]&&items[index].quantity||0);
            wheelTitles.push(product&&product.title||items[index]&&items[index].product_title||'Wheel');
          }
        });
        return{callOnly:callOnly,wheelQuantity:wheelQuantity,wheelTitles:wheelTitles};
      });
    }).catch(function(){return{callOnly:[],wheelQuantity:0,wheelTitles:[]};});
  }

  function handleCheckout(event){
    var target=event.target&&event.target.closest?event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]'):null;
    if(!target||target.getAttribute('data-hp-wheel-checkout-bypass')==='true')return;
    event.preventDefault();event.stopImmediatePropagation();
    cartWheelReview().then(function(review){
      if(review.callOnly.length){
        ask({eyebrow:'Cart review needed',title:'A call-only wheel is still in this cart.',message:'Please call Hurrey’s so we can verify and place the order correctly. Checkout stays paused until the call-only wheel is removed.',product:review.callOnly.map(function(item){return item.title;}).join(', '),actions:[{label:'Call 609-249-4921',href:'tel:6092494921'},{label:'Return to cart',value:'cancel',secondary:true}]});
        return;
      }
      function continueCheckout(){target.setAttribute('data-hp-wheel-checkout-bypass','true');if(target.tagName==='A')window.location.href=target.href;else target.click();}
      if(review.wheelQuantity>0&&review.wheelQuantity<4){
        ask({eyebrow:'Wheel quantity check',title:'This cart has only '+review.wheelQuantity+' wheel'+(review.wheelQuantity===1?'':'s')+'.',message:'Most wheel orders use four. Continue only if this is intentionally a replacement or staggered order.',product:review.wheelTitles.join(', '),actions:[{label:'Yes, continue to checkout',value:'continue'},{label:'Return to cart',value:'cancel',secondary:true}],foot:'This warning prevents an accidental one-wheel order; it does not block intentional replacement purchases.'}).then(function(choice){if(choice==='continue')continueCheckout();});
        return;
      }
      continueCheckout();
    });
  }

  document.addEventListener('submit',handleSubmit,true);
  document.addEventListener('click',handleCheckout,true);
})();
